const IMAGES = {
  mapGreenDot: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
};

export { IMAGES };
